export enum ERROR_CODES
{
    FETCHING_SUBTENANT_LIST = 'Error while fetching the subtenant list',
    FETCHING_SUBTENANT_INVOICES = 'Error while fetching the subtenant invoices',
    FETCHING_SINGLE_CONTACT = 'Error while fetching the contact',
    PROCESSING_SUBTENANT = 'Error while processing the subtenant',
    PROCESSING_CREDIT_TRANSFER = 'Error while processing the request for the transfer',
    UNLINKING_SUBTENANT = 'Error while unlinking the subtenant'
}